import { createSliceContext } from "./CreateSliceContext";

//props for the Footer slice context
interface FooterSliceProps {
  location: Location;
  showMerchandisingBlock: boolean;
}

const defaultFooterSliceValues: FooterSliceProps = {
  location: { pathname: "/" } as Location,
  showMerchandisingBlock: false,
};

export const {
  Provider: FooterSliceProvider,
  useContext: useFooterSliceContext,
} = createSliceContext<FooterSliceProps>("Footer", defaultFooterSliceValues);
